import { FluentProvider } from '@fluentui/react-components';
import { PropsWithChildren } from 'react';
import { darkTheme, lightTheme } from './fluentuiConfig';

import { useTheme } from '../../store/hooks';
import { LIGHT_THEME } from '../../store/models/theme';
import './ScrollBar.scss';

const FluentUiThemeProvider: React.FC<PropsWithChildren> = (props: PropsWithChildren) => {
    const { children } = props;
    const { theme } = useTheme();
    return <FluentProvider theme={theme === LIGHT_THEME ? lightTheme : darkTheme}>{children}</FluentProvider>;
};

export default FluentUiThemeProvider;
